import AccessibleClient from '@/dataAccess/models/AccessibleClient'
import DTO from '@/dataAccess/dto/DTO'

export default class ExpirationNotification extends DTO {
  static get url() {
    return 'expiration-notifications/'
  }

  clientId: number
  message: string
  expiringDate: string

  constructor({ clientId, message, expiringDate }) {
    super()
    this.clientId = clientId
    this.message = message
    this.expiringDate = expiringDate
  }

  get client() {
    return AccessibleClient.find(this.clientId)
  }
}
